<template>
  <div>
    <transition appear name="loading-bar">
      <loading-bar v-show="pending"/>
    </transition>

    <b-card-header
        class="mb-0"
        header-bg-variant="transparent"
    >
      <b-form @submit.prevent="fetchData">
        <b-row no-gutters>
          <b-col cols="auto">
            <b-form-group :label="$t('Type')">
              <b-form-select
                  v-model="params.type"
                  :options="types"
              >
                <template #first>
                  <b-form-select-option :value="undefined">{{ $t('All types') }}</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group :label="$t('Search')">
              <b-input-group>
                <b-form-input v-model="search"/>

                <b-input-group-append>
                  <b-button :title="$t('Search')" type="submit">
                    <fa icon="search"/>
                  </b-button>

                  <b-button
                      v-if="$gate.allow('create', 'foundation')"
                      :title="$t('Create new foundation')"
                      :to="{ name: 'projects.foundations.create', params: {projectId } }"
                      variant="primary"
                  >
                    <fa icon="plus"/>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <show-deleted-items v-model="params.onlyTrashed"/>
      </b-form>
    </b-card-header>

    <b-card-body v-if="!pending && !items.length">
      <no-results-found class="mb-0"/>
    </b-card-body>

    <b-list-group flush>
      <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
      >
        <project-foundation-list-item
            :api-url="apiUrl"
            :value="item"
            @created="handleCreated"
            @deleted="handleDelete"
            @input="handleUpdated"
        />
      </b-list-group-item>
    </b-list-group>

    <b-card-footer v-if="showPagination">
      <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          class="mb-0"
      />
    </b-card-footer>

    <router-view/>
  </div>
</template>
<script>
import ProjectFoundationListItem from "@/components/project_foundations/ListItem";
import crudListener from "@/mixins/crudListener";
import fetchPaginatedData from "@/mixins/fetchPaginatedData";
import {WALL_TYPES} from "@/constants";
import {sortBy} from "lodash";
import ShowDeletedItems from "@/components/ShowDeletedItems.vue";

export default {
  name: 'ProjectFoundations',
  components: {ShowDeletedItems, ProjectFoundationListItem},
  mixins: [fetchPaginatedData, crudListener],
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    apiUrl() {
      return '/api/projects/' + this.projectId + '/foundations';
    },
    resourceName() {
      return 'projects_foundations';
    },

    types() {
      let types = Object.values(WALL_TYPES).map(type => {
        return {
          value: type,
          text: this.$t(type),
        }
      })


      return sortBy(types, 'text');
    }

  },
  methods: {
    handleDelete(item) {
      this.items.splice(this.items.indexOf(item), 1);
    },

    handleCreated(item) {
      this.items.push(item);
    },

    handleUpdated(item) {
      let index = this.items.findIndex(({id}) => id === item.id);
      this.$set(this.items, index, item);
    },
  },
};
</script>
